import React from 'react'
import CardNew from 'presentation/shared/components/CardNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import DividerNew from 'presentation/shared/components/DividerNew'
import { ReactComponent as TrashIcon } from 'presentation/assets/icons/new-trash-green.svg'
import { Cid } from 'main/factories/pages/doctor/ambulatory-authorization/ambulatory-authorization-dashboard-factory'
import * as S from './styles'

type CidCardProps = {
  cid: Cid
  removeCid?: (code: number) => void
}

export const CidCard = ({ cid, removeCid }: CidCardProps) => {
  return (
    <CardNew key={cid?.code} style={{ width: '100%' }} shadow="satin">
      <S.CardHeader>
        <SupportTextNew color="neutral500" size="xsmall" weight="bold">
          {cid?.name}
        </SupportTextNew>
        {removeCid && (
          <S.TrashContainer onClick={() => removeCid(cid?.code)}>
            <TrashIcon width="24" height="24" />
          </S.TrashContainer>
        )}
      </S.CardHeader>

      <DividerNew marginTop="8px" marginBottom="16px" />

      <S.CardContent>
        <S.Row>
          <div>
            <TextFieldNew
              label="CID"
              labelSize="xxsmall"
              labelOverlapping
              baselineStyle
              // style={{ width: '80px' }}
              value={cid?.code}
              disabled
              requiredColor="neutral800"
            />
          </div>
        </S.Row>
      </S.CardContent>
    </CardNew>
  )
}
